import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as userActions from '../../actions/userActions';
import { Container, Row, Col, Table } from 'reactstrap';
import UserRow from './UserRow';
import { Button } from 'reactstrap';
import { withRouter } from 'react-router-dom';

class UserPage extends Component {
  componentWillMount() {
    this.props.actions.loadUsers();
  }

  redirectToAddUserPage = () => {
    this.props.history.push('/user');
  };

  render() {
    const { users } = this.props;
    return (
      <div>
        <Container fluid={true}>
          <Row>
            <Col md={12}>
              <h1 className="text-center my-4">Users</h1>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Button
                className="primary mb-2"
                onClick={this.redirectToAddUserPage}
              >
                Add
              </Button>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              {users.length > 0 ? (
                <Table>
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Username</th>
                      <th>Initials</th>
                      <th>Pay Rate</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.map((user) => (
                      <UserRow key={user.id} user={user} />
                    ))}
                  </tbody>
                </Table>
              ) : (
                <h4 className="my-4 ">No users found</h4>
              )}
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

UserPage.propTypes = {
  users: PropTypes.array.isRequired,
  actions: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    users: state.users,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(userActions, dispatch),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(UserPage)
);



// WEBPACK FOOTER //
// ./src/components/user/UserPage.js